const stap2 = {

	init() {

		// Draai check table functie on click op checkbox, cel en header images
		$('table.product-table input[type=checkbox], table.product-table tbody td, table.product-table thead th img').click(function() {
			setTimeout(function() {
				stap2.checkTable();
			}, 100);
		});

		// Draai check table functie on pageload
		stap2.checkTable();

		// Na het laden van de pagina, het mogelijk maken dat de producten tabel op verschillende manieren geselecteerd kan worden. Hierdoor kunnen producten per rrij geselecteerd worden, maar ook per kollom of cel
		$('table.product-table tr').click(function() {
			var curVerplichtMet = $(this).attr('data-verplichtMet');
			if (typeof curVerplichtMet != 'undefined' && curVerplichtMet != '') {
				var verplichtArray = curVerplichtMet.split('|');
				for (var i = 0; i < verplichtArray.length; i++) {
					$(this).find('td.checkbox_field input').each(function() {
						var checked = $(this).prop('checked');
						var id = $(this).attr('id');
						var idArray = id.split('_');
						idArray[1] = verplichtArray[i];
						if (checked == true) {
							$('#' + idArray.join('_')).prop('checked', true).parent().removeClass('checked').addClass('checked');
							stap2.checkVerplichtMetAanbieder($('#' + idArray.join('_')));
						} else {
							$('#' + idArray.join('_')).prop('checked', false).parent().removeClass('checked');
							stap2.checkVerplichtMetAanbieder($('#' + idArray.join('_')));
						}
					});
				}
			}
		});

		// Voegt de class 'checked' toe aan een cel in de tabel als de checkbox in die cel aangevinkt is
		$('table.product-table tr .checkbox_field input').each(function() {
			var target = $(this).parent();
			if ($(this).prop('checked') == true) {
				target.addClass('checked');
			} else {
				target.removeClass('checked');
			}
		});

		// click td - goed TODO: Comment
		$('table.product-table tr .checkbox_field').click(function() {
			if ($(this).hasClass('checked')) {
				$(this).removeClass('checked').children().prop('checked', false).trigger('change');
			} else {
				$(this).addClass('checked').children().prop('checked', true).trigger('change');
			}
		});

		// click first child PRODUCT - goed TODO: Comment
		$('table.product-table tr td:first-child').click(function() {
			var row = $(this).parent().parent().children().index($(this).parent()) + 1;
			var target = $(this).parent().parent().find('tr:nth-child(' + row + ') td');
			if (target.hasClass('checked')) {
				target.removeClass('checked');
				target.children().prop('checked', false).trigger('change');
			} else {
				target.addClass('checked');
				target.children().prop('checked', true).trigger('change');
			}
		});

		// hover first child PRODUCT - goed TODO: Comment
		$('table.product-table tr td:first-child').hover(
			function() {
				var row = $(this).parent().parent().children().index($(this).parent()) + 1;
				$(this).closest('table').find('tr:nth-child(' + row + ') td').addClass('hover');
			},
			function() {
				var row = $(this).parent().parent().children().index($(this).parent()) + 1;
				$(this).closest('table').find('tr:nth-child(' + row + ') td').removeClass('hover');
			}
		);

		// click first child Mij - goed TODO: Comment
		$('table.product-table tr th').click(function() {
			var col = $(this).parent().children().index($(this)) + 1;
			var target = $(this).parent().parent().parent().find('tr td:nth-child(' + col + ')');
			if (target.hasClass('checked')) {
				target.removeClass('checked');
				target.children().prop('checked', false).trigger('change');
			} else {
				target.addClass('checked');
				target.children().prop('checked', true).trigger('change');
			}
		});

		// hover first child Mij - goed TODO: Comment
		$('table.product-table tr th').not(':first-child').hover(
			function() {
				var col = $(this).parent().children().index($(this)) + 1;
				var target = $(this).parent().parent().parent().find('tr td:nth-child(' + col + ')');
				target.addClass('hover');
			},
			function() {
				var col = $(this).parent().children().index($(this)) + 1;
				var target = $(this).parent().parent().parent().find('tr td:nth-child(' + col + ')');
				target.removeClass('hover');
			}
		);

		// deselecteer alles - goed TODO: Comment
		$('table.product-table tr th:first-child button').click(function() {
			$(this).closest('table').find('tbody tr td').removeClass('checked').children().prop('checked', false);
		});

		// TODO: Comment
		$('input[type=checkbox][data-verplichtMetAanbieder]').on('change', function() {
			stap2.checkVerplichtMetAanbieder($(this));
		});
		if (typeof this.value !== 'undefined' && this.value == 'nee') {
			$('.kvk_data').prop('disabled', false);
			$('#NM_RELATIE').prop('disabled', true);
		} else {
			$('.kvk_data').prop('disabled', true);
		}


	},

	// Functie die checkt of in de producttabel voldoende maar niet te veel producten zijn aangevinkt
	checkTable: function() {
		var total = $('table.product-table').find('input[type=checkbox]:checked').length;

		if (total > 0) {
			$('button[type=submit]').removeAttr('disabled');
		}

		// per tr controleren hoeveel gecheckt zijn max 6 per regel
		var myArray = new Array();
		$('table.product-table tr').each(function() {
			var rowTotal = $(this).find('input[type=checkbox]:checked').length;
			myArray.push(rowTotal);
		});

		var maxValueInArray = Math.max.apply(Math, myArray);
		$('button[type=submit]').removeAttr('disabled');
		$('.button-row-message.warning').fadeOut(300);

		if (total == 0) {
			$('button[type=submit]').attr('disabled', 'true');
		} else {
			if (maxValueInArray > 8) {
				$('button[type=submit]').attr('disabled', 'true');
				$('.button-row-message.warning').fadeIn(300);
			}
			if (maxValueInArray < 9) {
				$('button[type=submit]').removeAttr('disabled');
				$('.button-row-message.warning').fadeOut(300);
			}
		}
	},

	// Functie die checkt of product verplicht is bij een andere aanbieder en vinkt het bijbehoorende product dan aan
	checkVerplichtMetAanbieder: function(t) {
		var verplichtMetAanbieder = $(t).attr('data-verplichtMetAanbieder');
		if (typeof verplichtMetAanbieder != 'undefined' && verplichtMetAanbieder != '') {
			var v = verplichtMetAanbieder.split('|');

			var r = $(t).closest('tr');
			r.find('input[type=checkbox][data-verplichtMetAanbieder]').each(function(i, el) {
				$.each(v, function(index, val) {
					if (el.getAttribute('id').match(val)) {
						$(el).prop('checked', $(t).prop('checked'));
					}
				});
			});
		}
	}


};

export default stap2;
